/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';

const style = {
  height: '150%',
  width: '100%',
  boxSizing: 'border-box',
  padding: 20
};

const ExamplePageOne = ({activeIndex}) => {
  return (
    <div style={style}><h3>Page {activeIndex+1}</h3><div>Try Scrolling</div></div>
  );
};

ExamplePageOne.propTypes = {
  activeIndex: PropTypes.number
};

export default ExamplePageOne;
